import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
import { isEmpty } from 'lodash';
import noImage from '../../../../assets/images/no-image.png';
import BtnDelete from '../../../../Components/Utility/FilterAction/BtnDelete';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';
import {
  getAllSubBrand,
  getAllBrands,
  getAllSeasons,
  getAllCategory1,
  getAllCategory2,
  getAllCategory3,
  getAllCategory4,
} from '../../../../services/SystemMaster.services';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import * as colourAction from '../store/ColorLibrary.action';
import ColourWayRefCard from '../../../../Components/Card/ColourWayRefCard/ColourWayRefCard';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import ColourImageDropZone from './ColourImageDropZone';
import { colourYear } from '../../../../Components/helper';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import { mergeGroupColours, toUniqueColourIds } from '../../../../Components/CommonColorWay/colour-group.helpers';
import '../colourLib.css';

const AsyncTypeahead = asyncContainer(Typeahead);

function AddEditColourWayGroupNew() {
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const paramId = params.id;
  const { t } = useTranslation('colourGroup');
  const typeaheadConfig = useRef(null);
  const ColourRefReduceres = useSelector((state) => state);
  const { UserDetails, SystemMastersDetails, ColorLibraryDetails } = ColourRefReduceres;
  const { userInfo } = UserDetails;
  const { ColorLibList, ColorLibGroupEdit, ColourOptions } = ColorLibraryDetails;
  const { subBrandAccess, pcTypeList } = SystemMastersDetails;
  const dispatch = useDispatch();
  const imagePath = 'data:image/png;base64';
  const loggedinUserId = userInfo?.userId;

  const [formData, setFormData] = useState({
    code: '',
    groupName: '',
    groupDescription: '',
    brand: null,
    subBrand: null,
    season: null,
    year: null,
    category1: null,
    category2: null,
    category3: null,
    category4: null,
    productType: null,
    colourWays: [],
  });

  const [errors, setErrors] = useState({});

  const [removeImage, setRemoveImage] = useState(false);
  const [originalImage, setOriginalImage] = useState('');
  const [prevcroppedImage, setPrevCroppedImage] = useState('');
  const [croppedImage, setCroppedImage] = useState('');
  const childRef = useRef();
  const [isNewUploaded, setIsNewUploaded] = useState(true);
  const [showImageUpload, setImgUpload] = useState(false);

  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [suggestionLoader, setsuggestionLoader] = useState(false);
  const [brandData, setBrandData] = useState([]);
  const [colourRefData, setColourRefData] = useState([]);
  const [colourRefDatatoShow, setColourRefDatatoShow] = useState([]);
  const [dataForEdit, setDataForEdit] = useState(null);
  const [seasonData, setSeasonData] = useState([]);
  const [cat1Data, setCat1Data] = useState([]);
  const [cat2Data, setCat2Data] = useState([]);
  const [cat3Data, setCat3Data] = useState([]);
  const [cat4Data, setCat4Data] = useState([]);
  const [isSubBrandAccess, setIsSubBrandAccess] = useState(false);
  const [subBrandOptions, setSubBrandOptions] = useState([]);
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);

  const getId = (val) => (val && typeof val === 'object' ? val?._id : val);

  const didRestoreRef = useRef(false);
  const duplicateNoticeShownRef = useRef(false);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.code?.trim()) {
      newErrors.code = t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.GROUP_CODE_REQUIRED');
    }

    if (!formData.groupName?.trim()) {
      newErrors.groupName = t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.GROUP_NAME_REQUIRED');
    }

    if (!formData.groupDescription?.trim()) {
      newErrors.groupDescription = t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.GROUP_DESCRIPTION_REQUIRED');
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const handleSelectBrand = (value) => {
    setFormData((prev) => ({
      ...prev,
      brand: value,
      subBrand: null,
    }));
    setSubBrandOptions([]);
    if (value?._id) {
      getAllSubBrand({
        brandId: value._id,
        loggedinUserId,
        forDropdown: true,
      })
        .then((res) => {
          if (res?.data?.length) setSubBrandOptions(res.data);
        })
        .catch(() => {});
    }
  };

  const handleSelectSubBrand = (value) => {
    setFormData((prev) => ({
      ...prev,
      subBrand: value,
    }));
  };

  const handleSelectSeason = (value) => {
    setFormData((prev) => ({
      ...prev,
      season: value,
    }));
  };

  const handleSelectYear = (value) => {
    setFormData((prev) => ({
      ...prev,
      year: value,
    }));
  };

  const handleSelectProductType = (value) => {
    setFormData((prev) => ({
      ...prev,
      productType: value,
      category1: null,
      category2: null,
      category3: null,
      category4: null,
    }));
  };

  const handleSelectCategory1 = (value) => {
    setFormData((prev) => ({
      ...prev,
      category1: value,
      category2: null,
      category3: null,
      category4: null,
    }));
  };

  const handleSelectCategory2 = (value) => {
    setFormData((prev) => ({
      ...prev,
      category2: value,
      category3: null,
      category4: null,
    }));
  };

  const handleSelectCategory3 = (value) => {
    setFormData((prev) => ({
      ...prev,
      category3: value,
      category4: null,
    }));
  };

  const handleSelectCategory4 = (value) => {
    setFormData((prev) => ({
      ...prev,
      category4: value,
    }));
  };

  const handleImageUpload = async (type) => {
    if (type !== 'close') {
      const croppedFileUrl = await childRef.current.showCroppedImg();
      const { imageRes, originalImg } = croppedFileUrl;
      const ogImage = await originalImg;
      setOriginalImage(ogImage);
      if (imageRes?.length > 0) setCroppedImage(imageRes);
      setIsNewUploaded(true);
      setRemoveImage(false);
    }
    setImgUpload(false);
  };

  useEffect(() => {
    if (subBrandAccess) {
      setIsSubBrandAccess(subBrandAccess);
    }
  }, [subBrandAccess]);

  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      try {
        const res = await dispatch(systemMasterAction.getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  const cat1DataDerived = useMemo(() => {
    if (!catBasedOnPTData) return cat1Data || [];
    if (!formData.productType) return [];
    const ptId = formData.productType?._id;
    return (cat1Data || []).filter((c1) => {
      const pts = c1?.productType || [];
      const arr = Array.isArray(pts) ? pts : [pts];
      const ids = arr.map((x) => x?._id || x).filter(Boolean);
      return ids.length ? ids.includes(ptId) : true;
    });
  }, [catBasedOnPTData, formData.productType, cat1Data]);

  const cat2DataDerived = useMemo(() => {
    if (!formData.category1?._id) return [];
    const c1Id = formData.category1?._id;
    return (cat2Data || []).filter((c2) => {
      const rel = c2?.categoryOneId || c2?.catOneIds || [];
      const arr = Array.isArray(rel) ? rel : [rel];
      const ids = arr.map((x) => x?._id || x).filter(Boolean);
      return ids.includes(c1Id);
    });
  }, [formData.category1?._id, cat2Data]);

  const cat3DataDerived = useMemo(() => {
    if (!formData.category1?._id || !formData.category2?._id) return [];
    const c1Id = formData.category1?._id;
    const c2Id = formData.category2?._id;
    return (cat3Data || []).filter((c3) => {
      const r1 = c3?.categoryOneId || c3?.catOneIds || [];
      const r2 = c3?.categoryTwoId || c3?.catTwoIds || [];
      const a1 = (Array.isArray(r1) ? r1 : [r1]).map((x) => x?._id || x).filter(Boolean);
      const a2 = (Array.isArray(r2) ? r2 : [r2]).map((x) => x?._id || x).filter(Boolean);
      return a1.includes(c1Id) && a2.includes(c2Id);
    });
  }, [formData.category1?._id, formData.category2?._id, cat3Data]);

  const cat4DataDerived = useMemo(() => {
    if (!formData.category3?._id) return [];
    const c1Id = formData.category1?._id;
    const c2Id = formData.category2?._id;
    const c3Id = formData.category3?._id;
    const base = cat4Data || [];

    const hasMeta = base.some((c4) => c4?.categoryThreeId || c4?.catThreeIds || c4?.categoryTwoId || c4?.catTwoIds || c4?.categoryOneId || c4?.catOneIds);
    if (!hasMeta) return base;

    return base.filter((c4) => {
      const r1 = c4?.categoryOneId || c4?.catOneIds || [];
      const r2 = c4?.categoryTwoId || c4?.catTwoIds || [];
      const r3 = c4?.categoryThreeId || c4?.catThreeIds || [];

      const a1 = (Array.isArray(r1) ? r1 : [r1]).map((x) => x?._id || x).filter(Boolean);
      const a2 = (Array.isArray(r2) ? r2 : [r2]).map((x) => x?._id || x).filter(Boolean);
      const a3 = (Array.isArray(r3) ? r3 : [r3]).map((x) => x?._id || x).filter(Boolean);

      const c1Match = c1Id ? a1.includes(c1Id) : true;
      const c2Match = c2Id ? a2.includes(c2Id) : true;
      const c3Match = a3.includes(c3Id);
      return c1Match && c2Match && c3Match;
    });
  }, [formData.category1?._id, formData.category2?._id, formData.category3?._id, cat4Data]);

  useEffect(() => {
    if (ColorLibGroupEdit && Object.values(ColorLibGroupEdit).length !== 0) {
      setDataForEdit(ColorLibGroupEdit);
    }
    return () => {
      setDataForEdit(null);
    };
  }, [ColorLibGroupEdit]);

  const initialExicution = async () => {
    const initParams = {
      isActive: 1,
      loggedInUserId: loggedinUserId,
    };
    const initParamsCat1 = {
      categoryType: 1,
      isActive: 1,
      loggedInUserId: loggedinUserId,
    };
    const initParamsCat2 = {
      categoryType: 2,
      isActive: 1,
      loggedInUserId: loggedinUserId,
    };

    if (location?.state?.libIds) {
      dispatch(colourAction.fetchColorLibrary({ loggedinUserId }));
    }

    const fetchCat1Cat2 = () => {
      Promise.all([getAllCategory1({ ...initParamsCat1, forDropdown: true }), getAllCategory2({ ...initParamsCat2, forDropdown: true })])
        .then(([res1, res2]) => {
          if (res1?.data?.length) setCat1Data(res1.data);
          if (res2?.data?.length) setCat2Data(res2.data);
        })
        .catch(() => {});
    };
    if (paramId !== undefined) {
      const initEditParams = {
        id: await paramId,
        groupId: await paramId,
        loggedInUserId: loggedinUserId,
        fromDetails: !dataForEdit?.catBasedOnPTData,
      };
      dispatch(colourAction.fetchColorGroupEditLibrary(initEditParams));
      fetchCat1Cat2();
      Promise.all([getAllBrands({ ...initParams, forDropdown: true }), getAllSeasons({ ...initParams, forDropdown: true })])
        .then(([brandRes, seasonRes]) => {
          if (brandRes?.data?.length) setBrandData(brandRes.data);
          if (seasonRes?.data?.length) setSeasonData(seasonRes.data);
        })
        .catch(() => {});
    } else {
      dispatch(systemMasterAction.getSubBrandAccess());
      fetchCat1Cat2();
      Promise.all([getAllBrands({ ...initParams, forDropdown: true }), getAllSeasons({ ...initParams, forDropdown: true })])
        .then(([brandRes, seasonRes]) => {
          if (brandRes?.data?.length) setBrandData(brandRes.data);
          if (seasonRes?.data?.length) setSeasonData(seasonRes.data);
        })
        .catch(() => {});
    }

    dispatch(
      systemMasterAction.getPCTypesDetails({
        loggedInUserId: loggedinUserId,
        isActive: true,
        tier: 'Tier1',
        forDropdown: true,
      }),
    );
  };

  useEffect(() => {
    initialExicution();
  }, []);

  useEffect(() => {
    if (paramId && dataForEdit && Object.values(dataForEdit).length !== 0) {
      setCroppedImage(dataForEdit.image ? dataForEdit.image : '');

      const initEditBrandParams = {
        isActive: 1,

        loggedInUserId: loggedinUserId,
      };

      const initEditSeasonParams = {
        isActive: 1,

        loggedInUserId: loggedinUserId,

        selectedSeason: dataForEdit?.seasonId,
      };

      const initParamsEditCat1 = {
        isActive: 1,

        loggedInUserId: loggedinUserId,

        categoryOneId: dataForEdit?.catOneId,

        categoryType: 1,
      };

      const initParamsEditCat2 = {
        isActive: 1,

        loggedInUserId: loggedinUserId,

        categoryTwoId: dataForEdit?.catTwoId,

        categoryType: 2,
      };

      const initParamsEditCat3 = {
        isActive: 1,

        loggedInUserId: loggedinUserId,

        categoryOneId: dataForEdit?.catOneId,

        categoryTwoId: dataForEdit?.catTwoId,

        categoryThreeId: dataForEdit?.catThreeId,

        categoryType: 3,
      };

      // Also fetch full active lists to populate options when edit filters return minimal sets

      const initParamsCat1 = { isActive: 1, loggedInUserId: loggedinUserId, categoryType: 1 };

      const initParamsCat2 = { isActive: 1, loggedInUserId: loggedinUserId, categoryType: 2 };

      const initParamsCat3 = {
        isActive: 1,

        loggedInUserId: loggedinUserId,

        categoryType: 3,
      };

      dispatch(systemMasterAction.getSubBrandAccess());

      Promise.all([
        getAllBrands({ ...initEditBrandParams, forDropdown: true }),

        getAllSeasons({ ...initEditSeasonParams, forDropdown: true }),

        getAllCategory1({ ...initParamsEditCat1, forDropdown: true }),

        getAllCategory2({ ...initParamsEditCat2, forDropdown: true }),

        getAllCategory3({ ...initParamsEditCat3, forDropdown: true }),

        getAllCategory1({ ...initParamsCat1, forDropdown: true }),

        getAllCategory2({ ...initParamsCat2, forDropdown: true }),

        getAllCategory3({ ...initParamsCat3, forDropdown: true }),
      ])

        .then(([brandRes, seasonRes, r1, r2, r3, r4, r5, r6]) => {
          if (brandRes?.data?.length) setBrandData(brandRes.data);

          if (seasonRes?.data?.length) setSeasonData(seasonRes.data);

          if (r1?.data?.length) setCat1Data(r1.data);
          else if (r4?.data?.length) setCat1Data(r4.data);

          if (r2?.data?.length) setCat2Data(r2.data);
          else if (r5?.data?.length) setCat2Data(r5.data);

          if (r3?.data?.length) setCat3Data(r3.data);
          else if (r6?.data?.length) setCat3Data(r6.data);
        })

        .catch(() => {});
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataForEdit]);

  useEffect(() => {
    const isCurrentGroupLoaded = !!paramId && !isEmpty(dataForEdit) && String(dataForEdit._id) === String(paramId);
    const savedColours = isCurrentGroupLoaded && Array.isArray(dataForEdit.colourWays) ? dataForEdit.colourWays : [];
    const libIds = location?.state?.libIds ?? [];
    const preselectedColours = libIds.length > 0 ? (colourRefData || []).filter((item) => libIds.includes(item?._id)) : [];

    if (!isCurrentGroupLoaded && !preselectedColours.length) {
      return;
    }

    const { colours, alreadyInGroup } = mergeGroupColours(savedColours, preselectedColours);
    setColourRefDatatoShow(colours);

    if (isCurrentGroupLoaded && alreadyInGroup.length && !duplicateNoticeShownRef.current) {
      duplicateNoticeShownRef.current = true;
      toasterMsg(
        t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.COLOUR_LIBRARY_ADDED', { name: alreadyInGroup.map((colour) => colour?.name).join(', ') }),
        'danger',
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colourRefData, dataForEdit]);
  const callCategory3 = async (cat1item, cat2item) => {
    const initParamsCat3 = {
      categoryOneId: cat1item._id,
      categoryTwoId: cat2item._id,
      categoryType: 3,
      isActive: 1,
      loggedInUserId: loggedinUserId,
      forDropdown: true,
    };
    try {
      const res = await getAllCategory3(initParamsCat3);
      if (res?.data?.length) setCat3Data(res.data);
      else setCat3Data([]);
    } catch {
      setCat3Data([]);
    }
  };

  const callCategory4 = async (cat1item, cat2item, cat3item) => {
    const initParamsCat4 = {
      categoryOneId: cat1item?._id,
      categoryTwoId: cat2item?._id,
      categoryThreeId: cat3item?._id,
      categoryType: 4,
      isActive: 1,
      loggedInUserId: loggedinUserId,
      forDropdown: true,
    };
    try {
      const res = await getAllCategory4(initParamsCat4);
      if (res?.data?.length) setCat4Data(res.data);
      else setCat4Data([]);
    } catch {
      setCat4Data([]);
    }
  };

  useEffect(() => {
    if (formData.category1 && formData.category2) {
      callCategory3(formData.category1, formData.category2);
    }
  }, [formData.category1, formData.category2]);

  useEffect(() => {
    if (formData.category1 && formData.category2 && formData.category3) {
      callCategory4(formData.category1, formData.category2, formData.category3);
    }
  }, [formData.category1, formData.category2, formData.category3]);

  useEffect(() => {
    if (!paramId || !dataForEdit?.catFourId || !cat4Data?.length || formData.category4) return;
    const catFourId = String(getId(dataForEdit.catFourId) ?? '');
    if (!catFourId) return;
    const match = cat4Data.find((c) => String(c?._id) === catFourId);
    if (match) setFormData((prev) => ({ ...prev, category4: match }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cat4Data]);

  useEffect(() => {
    if (paramId && dataForEdit?.brandId) {
      const brandId = getId(dataForEdit.brandId);
      if (!brandId) return;
      getAllSubBrand({
        brandId,
        loggedinUserId,
        forDropdown: true,
      })
        .then((res) => {
          if (res?.data?.length) setSubBrandOptions(res.data);
        })
        .catch(() => {});
    }
  }, [paramId, dataForEdit?.brandId, loggedinUserId]);

  useEffect(() => {
    if (paramId && dataForEdit?.catOneId && dataForEdit?.catTwoId) {
      const initParamsCat3 = {
        categoryOneId: dataForEdit.catOneId,
        categoryTwoId: dataForEdit.catTwoId,
        categoryType: 3,
        isActive: 1,
        loggedInUserId: loggedinUserId,
        forDropdown: true,
      };
      getAllCategory3(initParamsCat3)
        .then((res) => {
          if (res?.data?.length) setCat3Data(res.data);
        })
        .catch(() => {});
    }
  }, [paramId, dataForEdit?.catOneId, dataForEdit?.catTwoId, loggedinUserId]);

  useEffect(() => {
    const isdeletedFilteredArray = [...ColorLibList];
    const check = isdeletedFilteredArray.filter((element) => !element.isDeleted);
    const modifiedData = [...check];
    setColourRefData([...modifiedData]);
    return () => {
      setColourRefData([]);
    };
  }, [ColorLibList]);

  useEffect(() => {
    didRestoreRef.current = false;
  }, [paramId]);
  useEffect(() => {
    const hasCategoryData = (cat1Data?.length || dataForEdit?.catOneId == null) && (cat2Data?.length || dataForEdit?.catTwoId == null);
    if (paramId && dataForEdit && brandData?.length && hasCategoryData && !didRestoreRef.current) {
      const brandId = String(getId(dataForEdit.brandId) ?? '');
      const seasonId = String(getId(dataForEdit.seasonId) ?? '');
      const catOneId = String(getId(dataForEdit.catOneId) ?? '');
      const catTwoId = String(getId(dataForEdit.catTwoId) ?? '');
      const productTypeId = String(getId(dataForEdit.productTypeId || dataForEdit.productType?._id) ?? '');

      setFormData((prev) => ({
        ...prev,
        code: dataForEdit.code || '',
        groupName: dataForEdit.name || '',
        groupDescription: dataForEdit.description || '',
        brand: brandData.find((b) => String(b?._id) === brandId) || null,
        season: seasonData?.find((s) => String(s?._id) === seasonId) || null,
        year: colourYear?.find((y) => String(y?._id) === String(getId(dataForEdit.year))) || null,
        productType: pcTypeList?.find((p) => String(p?._id) === productTypeId) || null,
        category1: cat1Data?.find((c) => String(c?._id) === catOneId) || null,
        category2: cat2Data?.find((c) => String(c?._id) === catTwoId) || null,
        category3: null,
        category4: null,
        subBrand: null,
      }));

      if (dataForEdit.image) {
        setCroppedImage(dataForEdit.image);
        setOriginalImage(dataForEdit.fullImage);
        setPrevCroppedImage(dataForEdit.image);
        setIsNewUploaded(false);
      }

      didRestoreRef.current = true;
    }
  }, [dataForEdit, brandData, seasonData, cat1Data, cat2Data, pcTypeList, colourYear]);

  useEffect(() => {
    if (!paramId || !dataForEdit?.catThreeId || !cat3Data?.length || formData.category3) return;
    const catThreeId = String(getId(dataForEdit.catThreeId) ?? '');
    if (!catThreeId) return;
    const match = cat3Data.find((c) => String(c?._id) === catThreeId);
    if (match) setFormData((prev) => ({ ...prev, category3: match }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cat3Data]);

  useEffect(() => {
    if (!paramId || !dataForEdit?.subBrandId || !subBrandOptions?.length || formData.subBrand) return;
    const subBrandId = String(getId(dataForEdit.subBrandId) ?? '');
    if (!subBrandId) return;
    const match = subBrandOptions.find((sb) => String(sb?._id) === subBrandId);
    if (match) setFormData((prev) => ({ ...prev, subBrand: match }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subBrandOptions]);

  const brandSelectValue = useMemo(() => brandData?.find((b) => b._id === formData.brand?._id) ?? formData.brand ?? null, [brandData, formData.brand]);

  const handleDeleteCard = (id) => {
    const selectedItems = [...selectedIdArray];
    let colourRefs = [...colourRefDatatoShow];
    if (id === null) {
      colourRefs = colourRefs.filter((item) => !selectedItems.includes(item._id));
      setSelectedIdArray([]);
      setColourRefDatatoShow(colourRefs);
    } else {
      const xx = colourRefDatatoShow?.findIndex((ele) => ele._id === id);
      colourRefDatatoShow.splice(xx, 1);
      setColourRefDatatoShow([...colourRefDatatoShow]);
    }
  };

  const onSelectCheckBox = async (_e, id) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems.filter((item) => item === id);
    if (findItems.length > 0) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
    } else {
      setSelectedIdArray([...selectedItems, id]);
    }
  };

  const onAutoSuggestion = async (selected) => {
    const typeaheadConfigRef = typeaheadConfig.current;
    let similarColour;
    const selectedColour = selected?.[0];

    if (colourRefDatatoShow && !isEmpty(colourRefDatatoShow)) {
      similarColour = colourRefDatatoShow.filter((colEle) => colEle._id === selectedColour?._id);
    }
    if (similarColour && !isEmpty(similarColour)) {
      toasterMsg(t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.COLOUR_LIBRARY_ADDED', { name: selectedColour?.name }), 'danger');
    } else {
      setColourRefDatatoShow((colourRefDatatoSho) => [...colourRefDatatoSho, ...selected]);
    }
    if (typeaheadConfigRef) typeaheadConfigRef.clear();
  };

  const promiseSearch = async (inputValue) => {
    if (inputValue && inputValue.trim().length !== 0) {
      setsuggestionLoader((prev) => !prev);
      const searchParams = {
        loggedinUserId,
        searchText: inputValue,
        from: 'search',
      };
      dispatch(colourAction.fetchColorLibrary(searchParams));
      setsuggestionLoader((prev) => !prev);
    }
  };

  const setimages = (paramName) => {
    if (croppedImage !== prevcroppedImage) {
      paramName.image = croppedImage;
      paramName.fullImage = originalImage;
      paramName.removeImage = removeImage;
    }
  };

  const onSubmitMethod = async () => {
    if (!validateForm()) {
      return;
    }

    const data = {
      ...formData,
      colourWays: toUniqueColourIds(colourRefDatatoShow),
    };

    if (paramId) {
      const putParams = {
        brandId: data?.brand?._id || null,
        catOneId: data?.category1?._id || null,
        catTwoId: data?.category2?._id || null,
        catThreeId: data?.category3?._id || null,
        catFourId: data?.category4?._id || null,
        colourWays: data.colourWays ? JSON.stringify(data.colourWays) : JSON.stringify([]),
        code: data.code,
        loggedInUserId: loggedinUserId,
        name: data.groupName,
        description: data.groupDescription,
        seasonId: data?.season?._id || null,
        year: data?.year?._id || '',
        isCodeAdded: !!data.code,
      };
      if (catBasedOnPTData) {
        putParams.productTypeId = data?.productType?._id || null;
      }
      if (data.subBrand) {
        putParams.subBrandId = data?.subBrand?._id || null;
      }
      setimages(putParams);
      dispatch(colourAction.editColorGroupLibrary(putParams, paramId, t));
    } else {
      const postParams = {
        brandId: data?.brand?._id || null,
        catOneId: data?.category1?._id || null,
        catTwoId: data?.category2?._id || null,
        catThreeId: data?.category3?._id || null,
        catFourId: data?.category4?._id || null,
        colourWays: data.colourWays ? JSON.stringify(data.colourWays) : JSON.stringify([]),
        code: data.code,
        loggedInUserId: loggedinUserId,
        name: data.groupName,
        description: data.groupDescription,
        seasonId: data?.season?._id || null,
        year: data?.year?._id || '',
        isCodeAdded: !!data.code,
      };
      if (catBasedOnPTData) {
        postParams.productTypeId = data?.productType?._id || null;
      }
      if (data.subBrand) {
        postParams.subBrandId = data?.subBrand?._id || null;
      }
      if (croppedImage) {
        setimages(postParams);
      }
      dispatch(colourAction.addColorLibraryGroup(postParams, t));
    }
  };

  const onCancle = async () => {
    history.push('/libraries/colour-groups');
    dispatch(colourAction.emptyReducer());
  };

  const imgSrcs = () => {
    return croppedImage || noImage;
  };

  const colourOptionsMemoized = useMemo(() => (Array.isArray(ColourOptions) ? ColourOptions : []), [ColourOptions]);

  return (
    <div className="colour-way-group-container">
      <div className="page-title-filter sticky colour-way-action">
        <div className="title-container">
          <h4 className="title">{paramId ? t('COMMON_LABEL.EDIT_GROUP') : t('COMMON_LABEL.CREATE_GROUP')}</h4>
        </div>
        <figure className="pom-edit-figure ">
          <img width="47" src={imgSrcs()} alt="croppedImage" />
        </figure>
        <div className="search-filter floting-actions">
          <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.SAVE')}>
            <button aria-label="Save" type="button" name="Save" className="btn " onClick={onSubmitMethod}>
              <i className="icon-Save-1 f-20" />
            </button>
          </CustomTooltip>
          <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.UPLOAD_IMAGE')}>
            <button aria-label="upload" className="btn py-0" type="button" onClick={() => setImgUpload(true)}>
              <i className="icon-Upload-1 f-28" />
            </button>
          </CustomTooltip>
          <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.CANCEL')}>
            <button aria-label={t('COMMON_LABEL.CANCEL')} type="button" className="btn" onClick={onCancle}>
              <i className="icon-close " />
            </button>
          </CustomTooltip>
        </div>
      </div>
      <div className="container-fluid colour-group-container">
        <div className="row mt-4">
          <Col lg="4">
            <div className="common-input-control">
              <p className="field-name">
                {t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.GROUP_CODE')}
                <span className="asterisk">*</span>
              </p>
              <input
                type="text"
                name="code"
                value={formData.code}
                onChange={handleInputChange}
                placeholder={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.GROUP_CODE')}
                className="form-control"
                maxLength={5}
              />
              {errors.code && <span className="error-message">{errors.code}</span>}
            </div>
          </Col>

          <Col lg="3">
            <div className="common-input-control">
              <p className="field-name">
                {t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.GROUP_NAME')}
                <span className="asterisk">*</span>
              </p>
              <input
                type="text"
                name="groupName"
                value={formData.groupName}
                onChange={handleInputChange}
                placeholder={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.GROUP_NAME')}
                className="form-control"
              />
              {errors.groupName && <span className="error-message">{errors.groupName}</span>}
            </div>
          </Col>
          <Col lg="5">
            <FormGroup>
              <div className="common-input-control">
                <p className="field-name">
                  {t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.GROUP_DESCRIPTION')}
                  <span className="asterisk">*</span>
                </p>
                <input
                  type="text"
                  name="groupDescription"
                  value={formData.groupDescription}
                  onChange={handleInputChange}
                  placeholder={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.GROUP_DESCRIPTION')}
                  className="form-control"
                />
                {errors.groupDescription && <span className="error-message">{errors.groupDescription}</span>}
              </div>
            </FormGroup>
          </Col>
        </div>

        <div className="row mt-3 mb-3">
          <Col lg="2">
            <div className="common-react-select mb-0">
              <p className="field-name mt-0">{t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.BRAND')}</p>
              <Select
                name="brand"
                options={brandData}
                getOptionLabel={(option) => option?.name ?? ''}
                getOptionValue={(option) => option?._id}
                value={brandSelectValue}
                className="common-select"
                classNamePrefix="common-select"
                isClearable
                onChange={handleSelectBrand}
                placeholder={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.SELECT_BRAND')}
              />
            </div>
          </Col>
          {isSubBrandAccess && (
            <Col lg="2">
              <div className="common-react-select mb-0">
                <p className="field-name mt-0">{t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.SUBBRAND')}</p>
                <Select
                  name="subBrand"
                  options={subBrandOptions.filter((e) => e.isActive)}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option._id}`}
                  value={formData.subBrand}
                  className="common-select"
                  classNamePrefix="common-select"
                  isClearable
                  onChange={handleSelectSubBrand}
                  placeholder="Select Sub Brand"
                />
              </div>
            </Col>
          )}
          <Col lg="2">
            <div className="common-react-select mb-0">
              <p className="field-name mt-0">{t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.SEASON')}</p>
              <Select
                name="season"
                options={seasonData}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                value={formData.season}
                className="common-select"
                classNamePrefix="common-select"
                isClearable
                onChange={handleSelectSeason}
                placeholder={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.SELECT_SEASON')}
              />
            </div>
          </Col>
          <Col lg="2">
            <div className="common-react-select mb-0">
              <p className="field-name mt-0">{t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.YEAR')}</p>
              <Select
                name="year"
                options={colourYear}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                value={formData.year}
                className="common-select"
                classNamePrefix="common-select"
                isClearable
                onChange={handleSelectYear}
                placeholder={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.SELECT_YEAR')}
              />
            </div>
          </Col>
          {catBasedOnPTData && (
            <Col lg="2">
              <div className="common-react-select mb-0">
                <p className="field-name mt-0">{t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.PRODUCT_TYPE')}</p>
                <Select
                  name="productType"
                  options={pcTypeList}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option._id}`}
                  value={formData.productType}
                  className="common-select"
                  classNamePrefix="common-select"
                  isClearable
                  onChange={handleSelectProductType}
                  placeholder="Select Product Type"
                />
              </div>
            </Col>
          )}
          <Col lg="2">
            <div className="common-react-select mb-0">
              <p className="field-name mt-0">{t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.CATEGORY_1')}</p>
              <Select
                name="category1"
                options={cat1DataDerived}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                value={formData.category1}
                isDisabled={catBasedOnPTData && !formData.productType}
                className="common-select"
                classNamePrefix="common-select"
                isClearable
                onChange={handleSelectCategory1}
                placeholder={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.SELECT_CATEGORY')}
              />
            </div>
          </Col>
          <Col lg="2">
            <div className={`common-react-select mb-0 ${catBasedOnPTData ? 'mt-3' : ''}`}>
              <p className="field-name mt-0">{t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.CATEGORY2')}</p>
              <Select
                name="category2"
                options={catBasedOnPTData ? cat2DataDerived : cat2Data}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                value={formData.category2}
                isDisabled={catBasedOnPTData && !formData.category1?._id}
                className="common-select"
                classNamePrefix="common-select"
                isClearable
                onChange={handleSelectCategory2}
                placeholder={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.SELECT_CATEGORY2')}
              />
            </div>
          </Col>
          <Col lg="2">
            <div className={`common-react-select mb-0 ${isSubBrandAccess ? 'mt-3' : ''}`}>
              <p className="field-name ">{t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.CATEGORY3')}</p>
              <Select
                name="category3"
                options={catBasedOnPTData ? cat3DataDerived : cat3Data}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                value={formData.category3}
                isDisabled={catBasedOnPTData && (!formData.category1?._id || !formData.category2?._id)}
                className="common-select"
                classNamePrefix="common-select"
                isClearable
                onChange={handleSelectCategory3}
                placeholder={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.SELECT_CATEGORY3')}
              />
            </div>
          </Col>
          <Col lg="2">
            <div className="common-react-select mb-0 mt-3">
              <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGORY4')}</p>
              <Select
                name="category4"
                options={cat4DataDerived}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                value={formData.category4}
                className="common-select"
                classNamePrefix="common-select"
                isClearable
                onChange={handleSelectCategory4}
                placeholder="Select Category 4"
              />
            </div>
          </Col>
        </div>
        <div className="row">
          <div className="col-lg-2 d-flex search-color-lib-container mb-4">
            <AsyncTypeahead
              id="typeheadWithColours"
              className="custom-AsyncTypeHead colour-typehead f-18 font-medium"
              isLoading={suggestionLoader}
              labelKey="name"
              minLength={1}
              onSearch={(query) => promiseSearch(query)}
              options={colourOptionsMemoized}
              ref={typeaheadConfig}
              promptText="No Colour found"
              placeholder={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.SEARCH_COLOUR_LIBRAY')}
              useCache={false}
              onChange={(selected) => onAutoSuggestion(selected)}
              renderMenuItemChildren={(option) => <div key={option._id}>{option?.refName}</div>}
            />
            <div className="btn-outline-container">
              <BtnDelete
                multiDelete={() => {
                  handleDeleteCard(null);
                }}
                isDisabled={isEmpty(selectedIdArray)}
              />
            </div>
          </div>
        </div>
        {showImageUpload && (
          <ColourImageDropZone
            showImageUpload={showImageUpload}
            childRef={childRef}
            handleImageUpload={handleImageUpload}
            srcImage={() => originalImage || croppedImage}
            isNewUploaded={isNewUploaded}
            oldAndNewImage={() => (originalImage?.includes(imagePath) ? true : !!croppedImage?.includes(imagePath))}
          />
        )}

        {colourRefDatatoShow && colourRefDatatoShow.length !== 0 && (
          <div className="row">
            {colourRefDatatoShow.map((item, i) => {
              return (
                <React.Fragment key={item?._id}>
                  <ColourWayRefCard
                    editeble
                    item={item}
                    index={i}
                    onDelete={handleDeleteCard}
                    onCheck={onSelectCheckBox}
                    selectedIds={selectedIdArray}
                    isImport={false}
                    disabled={false}
                  />
                </React.Fragment>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default AddEditColourWayGroupNew;
